module.exports = __webpack_public_path__ + "img/C05TechFortifications_ua.e8633455.webp";